import cx from 'classnames'
import Styles from './Properties.module.scss'
import { useFinderContext } from 'screens/Finder/FinderContext'
import { ConfirmModal } from './ConfirmModal'
import { ReactComponent as TrashIcon } from 'assets/icons/trash16.svg'
import { Button } from 'components/Button/Button'
import { Property } from 'api/clients/PropertyClient'
import { useModals } from 'almanac-ui/Modal'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { usePropertiesList } from 'common/PropertiesList/usePropertiesList'
import { removeProperty } from 'redux/actions/properties'
import { useDispatch } from 'react-redux'

type Props = {
  property: Property
  onClose: () => void
}

export const DeleteProperty = ({ property, onClose }: Props) => {
  const dispatch = useDispatch()
  const { openModal, closeModal } = useModals()
  const { filesView, removePropertyFromSchema, refresh: refreshFinder } = useFinderContext()
  const currentWorkspace = useCurrentWorkspace()
  const { deleteProperty } = usePropertiesList({ workspaceId: currentWorkspace?.key || '' })

  const onConfirm = async () => {
    if (filesView?.schema.properties.some(({ id }) => property.id === id)) {
      await removePropertyFromSchema(property.id)
    }
    await deleteProperty(property)
    dispatch(removeProperty(property.id))
    refreshFinder()
    closeModal()
    showToastMessage(`"${property.name}" has been deleted.`)
  }

  const openDeleteConfirm = () => {
    onClose()
    if (filesView)
      openModal(ConfirmModal, {
        onConfirm,
        property,
        filesView,
      })
  }

  return (
    <div className={Styles.flexContainer}>
      <Button
        className={cx(Styles.flexContainer, Styles.flexGrow, Styles.horizontalPadding, Styles.columnGap0)}
        variant="tertiary"
        size="lg"
        onPress={openDeleteConfirm}
      >
        <TrashIcon className={Styles.icon} />
        <div>Delete</div>
      </Button>
    </div>
  )
}
